<template>
    <div
        class="c-switch-list c-switch-list--date"
        :class="{
            'is-disabled': isDatesDisabled,
            'is-initial': isInitialDatesFetch,
        }"
    >
        <template v-if="isInitialDatesFetch || isDatesDisabled">
            <div class="c-switch-list__item" v-for="i in 7" :key="i" />
            <div class="c-switch-list__item is-datepicker" />
        </template>

        <template v-else>
            <button
                type="button"
                class="c-switch-list__item"
                v-for="date in first7Dates"
                :key="date.id"
                :class="{ 'is-selected': date.id == selectedDateId }"
                @click="changeDate(date.id)"
            >
                <div class="sc-text">
                    {{ getDayFromDate(date.date) }}
                </div>

                <strong class="sc-strong">
                    {{ getFormattedDate(date.date) }}
                </strong>
            </button>

            <button
                type="button"
                class="c-switch-list__item js-switch-datepicker"
                :class="{
                    'is-datepicker': !hasOtherDateSelected,
                    'is-selected': hasOtherDateSelected,
                    'is-selected-datepicker': hasOtherDateSelected,
                }"
                v-if="dates.length > 7 && false"
                ref="datepicker"
            >
                <template v-if="hasOtherDateSelected">
                    <strong class="sc-strong">
                        {{
                            getDayFromDate(selectedDate.date) +
                            " - " +
                            getFormattedDate(selectedDate.date)
                        }}
                    </strong>

                    <div class="sc-link">
                        {{ $t("Switch.Dates.change") }}
                    </div>
                </template>

                <template v-else>
                    <i class="ico ico-calendar"></i>
                    <span>{{ $t("Switch.Dates.selectDay") }}</span>
                </template>
            </button>
        </template>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import flatpickr from "flatpickr";
import { Slovak } from "flatpickr/dist/l10n/sk";

export default {
    data() {
        return {
            flatpickrInstance: null,
        };
    },
    methods: {
        changeDate(dateId) {
            this.$store.commit("SET_SELECTED_DATE_ID", dateId);
            this.$store.dispatch("fetchTimes");

            // toto mozno odstranit a mozno bude fungovat? treba skusit
            this.initializeDatepicker();
        },
        getDayFromDate(date) {
            const tmpDate = new Date(date);

            return tmpDate.toLocaleDateString("sk-SK", {
                weekday: "short",
            });
        },
        getFormattedDate(date) {
            const tmpDate = new Date(date);

            return tmpDate
                .toLocaleDateString("sk-SK", {
                    day: "numeric",
                    month: "short",
                })
                .replace(/\s+/g, "");
        },

        initializeDatepicker() {
            const datepickerElem = this.$refs.datepicker;
            const tmpThis = this;

            if (!datepickerElem) {
                return;
            }

            datepickerElem.setAttribute("autocomplete", "off");

            if (this.flatpickrInstance) {
                this.flatpickrInstance.destroy();
                this.flatpickrInstance = null;
            }

            this.flatpickrInstance = flatpickr(datepickerElem, {
                disableMobile: true,
                allowInput: true,
                locale: Slovak,
                dateFormat: "Y-m-d",
                defaultDate: this.selectedDate.date,
                enable: this.simpleDates,
                onChange: function (selectedDates, dateStr, instance) {
                    if (dateStr != tmpThis.selectedDate.date) {
                        tmpThis.changeDate(tmpThis.dates.find((date) => date.date == dateStr).id);
                    }
                },
            });
        },
    },
    computed: {
        ...mapState(["selectedDateId", "isInitialDatesFetch", "dates", "isDatesDisabled"]),
        ...mapGetters(["selectedDate", "first7Dates", "simpleDates", "hasOtherDateSelected"]),
    },
    watch: {
        dates: {
            handler() {
                setTimeout(() => this.initializeDatepicker(), 500);
            },
            deep: true,
        },
    },
};
</script>
